// extracted by mini-css-extract-plugin
module.exports = {"panels":"ScreenerSettingsContentComponent_panels__1m_C9","items":"ScreenerSettingsContentComponent_items__39Gdo"};